﻿'use strict';

angular.module('ntmApp').factory('MultiSelectFilter', function () {

    function MultiSelectFilter(blankSimpleDisplayLabel, getLabelAction) {


        this.selectedItems = [];
        this.displayLabelAction = getLabelAction;

        this.isDefined = function () {
            return this.selectedItems.length > 0;
        };

        this.isPartlyDefined = function () {
            return this.isDefined();
        };

        this.clear = function () {
            this.selectedItems = [];
        };

        this.getLabel = function () {

            var items = this.selectedItems.map(function (item) {
                return getItemValueConsideringBlankOPtion(item);
            }).join("; ");


            if (this.displayLabelAction) {
                return this.displayLabelAction(items);
            } else {
                return items;

            }


            return this.selectedItems.map(function (item) {
                return getItemValueConsideringBlankOPtion(item);
            }).join("; ");
        };

        function getItemValueConsideringBlankOPtion(item) {

            if (item.id && item.value) {
                return item.value;
            }

          /*  if (item.id && !item.value) {
                this.selectedItems.forEach(function (tmp) {
                    if (tmp.id === item.id) {
                        return item.value;
                    }
                });
            }*/

            return blankSimpleDisplayLabel ? blankSimpleDisplayLabel : item.value;

        }
    }

    return (MultiSelectFilter);
});